<div class="ib-box-info--flex" [class]="extraClass">
    <div class="ib-box-info ib-box-info--type-volrefund">
        <div class="ib-box-info__wrapper">
            <h2 class="ib-box-info__title">{{"MMB_DISRUPTION_CALLCENTER_DOUBTS" | translate}}</h2>
            <div class="ib-box-info__container">
                <p class="ib-box-info__text">{{"MMB_DISRUPTION_CALLCENTER_CONTACT_MSG_NO_PHONE" | translate}}</p>
            </div>
        </div>
    </div>
</div>
